export interface TypeInfo {
  code: string;
  cn: string;
  intro: string;
  desc: string;
}

export interface NormalType {
  code: string;
  pattern: string;
}

export const TYPE_LIBRARY: Record<string, TypeInfo> = {
  CTRL: {
    code: 'CTRL',
    cn: '拿捏者',
    intro: '怎么样，被我拿捏了吧？',
    desc: '恭喜您，您测出了全中国最为罕见的人格，您是宇宙熵增定律的天然反抗者！全世界所谓成功人士里，99.99%都是您的拙劣模仿者。CTRL人格，是行走的人形自走任务管理器，普通人眼中的"规则"，在您这里只是出厂的基础参数设置；凡人所谓的"计划"，对您而言不过是心血来潮的随手涂鸦。拥有一个CTRL朋友意味着什么？意味着你的人生导航系统会变得更加精准、高效。因为CTRL最会拿捏了。CTRL会在你人生列车即将脱轨的前一秒，用一个"Ctrl+S"帮你硬核存档，再用一套无法拒绝的逻辑把你强行拽回正轨。他们是你混乱生活最后的备份盘，是宇宙崩塌前唯一还亮着的那个重启键。',
  },
  'ATM-er': {
    code: 'ATM-er',
    cn: '送钱者',
    intro: '你以为我很有钱吗？',
    desc: '恭喜您，您竟然测出了这个世界上最稀有的人格。您或将成为金融界的未解之谜——是的，ATM-er不一定真的"送钱"，但可能永远在"支付"。支付时间、支付精力、支付耐心、支付一个本该安宁的夜晚。因此像一部老旧但坚固的ATM机，插进去的是别人的焦虑和麻烦，吐出来的是"没事，有我"的安心保证。您的人生就是一场盛大的、无人喝彩的单人付账秀。您竟用磐石般的可靠，承受了瀑布般的索取，偶尔夜深人静才会对着账单——可能是精神上的——发出一声叹息：我这该死的、无处安放的责任心啊。',
  },
  'Dior-s': {
    code: 'Dior-s',
    cn: '屌丝',
    intro: '等着我屌丝逆袭。',
    desc: '恭喜！您并非屌丝，您是犬儒主义先贤第欧根尼失散多年的精神传人，因为屌丝的全称是 Diogenes\' Original Realist - sage。Dior-s人格，是对当代消费主义陷阱和成功学PUA最彻底的蔑视。他们不是"不求上进"，而是早已看穿一切"上进"的尽头不过是更高级的牢房。屌丝有着大智慧。当别人在追逐风口，被时代的巨浪拍得七荤八素时，Dior-s早已在自己的精神木桶里晒着太阳，达到了"人桶合一"的至高境界。他们信奉的不是空话，是经过亿万次实践检验的物理法则与生物本能：一、躺着比站着舒服；二、饭点到了就得干饭。',
  },
  BOSS: {
    code: 'BOSS',
    cn: '领导者',
    intro: '方向盘给我，我来开。',
    desc: 'BOSS是一个手里永远拿着方向盘的人。哪怕油箱已经亮了红灯，哪怕导航在胡说八道，你都会面无表情地说一句：我来开。然后真的把车开到了目的地。该人格拥有独立的物理法则——永恒向上定律。BOSS人格看世界，就像玩通关了的玩家在看新手教程。效率是他们的信仰，秩序是他们的呼吸。他们不是"自带领袖气场"，他们本身就是人形的气场发生器，方圆五米内，空气都会自动变得严肃而高效。他们眼中的"自我突破"，约等于普通人眼中的"自虐"。今天掌握一门新语言，明天考下一个专业证书，后天就计划殖民火星。你说这太卷了，他会用一种看弱鸡的眼神看着你：不是我太狠，是你太松。',
  },
  'THAN-K': {
    code: 'THAN-K',
    cn: '感恩者',
    intro: '我感谢苍天！我感谢大地！',
    desc: '恭喜您，您测出了全中国最为罕见的人格。您应当感谢我！感谢您在此刻拥有了生命的滋润！倘若您上班路上堵车了？您也应当说一句：我感谢这次堵车，它让我有更多时间聆听这首美妙的歌曲，并欣赏窗外每一张因焦虑而扭曲的脸庞，让我更珍惜内心的平静。是的，THAN-K拥有温润如玉的性格和海纳百川的胸怀。他们眼中的世界没有完全的坏人，只有"尚未被感恩光芒照耀到的朋友"。拥有一个THAN-K朋友，就像身边多了一个永不枯竭的正能量发射塔。TA甚至能帮你从墙角的霉斑里发现一幅梵高风格的星空图。',
  },
  'OH-NO': {
    code: 'OH-NO',
    cn: '哦不人',
    intro: '哦不！我怎么会是这个人格？！',
    desc: '"哦不！"并非恐惧的尖叫，而是一种顶级的智慧。当普通人看到一个杯子放在桌沿，哦不人看到的是一场由"水渍-短路-火灾-全楼疏散-经济损失-蝴蝶效应-世界末日"构成的灾难史诗。于是，伴随着一声发自灵魂深处的 Oh, no!，他们会以迅雷不及掩耳之势把杯子挪到桌子正中央，然后再垫上一张吸水杯垫。哦不人对"边界"有一种近乎偏执的尊重：你的就是你的，我的就是我的。所有意外和风险都已经在他的"Oh, no!"声中，被扼杀在了萌芽状态。他们是秩序的守护神，是混乱世界里最后那批神经绷得很直的体面人。',
  },
  GOGO: {
    code: 'GOGO',
    cn: '行者',
    intro: 'gogogo~出发咯',
    desc: '经研究发现，GOGO人格的大脑构造与常人有根本性不同。GOGO活在一个极致的"所见即所得"世界里，人生信条简单粗暴到令人发指：只要我闭上眼睛，天就是黑的；只要我把钱都花了，我就没有钱了；只要我站在斑马线上，我现在就是行人了。逻辑完美闭环，根本无法反驳。别人还在为"先有鸡还是先有蛋"而辩论，GOGO行者已经把鸡和蛋一起做成了一盘"鸡生蛋，蛋生鸡之终极奥义盖浇饭"。他们不是在"解决问题"，他们是在"清除待办事项"。对他们来说，世界上只有两种状态：已完成，和即将被我完成。',
  },
  SEXY: {
    code: 'SEXY',
    cn: '尤物',
    intro: '您就是天生的尤物！',
    desc: '当您走进一个房间，照明系统会自动将您识别为天生的尤物，并自觉调暗亮度，以避免能源浪费。当您微笑时，您就变成了微笑着的尤物，周围的空气湿度也会显著下降，因为水蒸气都凝结成了人眼中的爱心。无论是谁，都容易对您的存在产生一种超标的注意力。传说，如果有足够多的SEXY人格聚集在一起开派对，其释放出的综合魅力能量足以暂时扭曲时空结构，让参加者产生"时间变慢了"的幸福错觉。他们不需要卖力表达，很多时候，单是存在本身就已经很像一篇华丽到过分的赋。',
  },
  'LOVE-R': {
    code: 'LOVE-R',
    cn: '多情者',
    intro: '爱意太满，现实显得有点贫瘠。',
    desc: 'LOVE-R人格像远古神话时代幸存至今的珍稀物种，其存在概率比你在马桶里钓到作者胳膊的概率还低。您简直是这个钢铁森林时代最后的、也是最不合时宜的吟游诗人。因为您的情感处理器不是二进制的，而是彩虹制的。一片落叶，在常人眼里只是"秋天来了"，在LOVE-R眼中，则是一场关于轮回、牺牲与无言之爱的十三幕悲喜剧。您内心世界像一座永不关门的主题公园，一生都在寻找那个能看懂园区地图、并愿意陪你坐旋转木马直到宇宙尽头的灵魂伴侣。',
  },
  MUM: {
    code: 'MUM',
    cn: '妈妈',
    intro: '或许……我可以叫你妈妈吗……？',
    desc: '恭喜您，您测出了全中国最稀有的妈妈人格。是的，在混沌未开、时间尚无姓名之前，在第一颗恒星打出第一个嗝之前，就已经有了妈妈。妈妈人格的底色是温柔，擅长感知情绪，具有超强共情力，知道什么时候该停下来，什么时候该对自己说一句"算了"。妈妈像一个医生，治愈了别人的不开心。只可惜，当妈妈落泪时，TA给自己的药，剂量总是比给别人小一号。MUM对自己的温柔，常常打了折。',
  },
  FAKE: {
    code: 'FAKE',
    cn: '伪人',
    intro: '已经，没有人类了。',
    desc: 'SCP基金会紧急报告：项目编号 SCP-CN-████ "伪人"。在社交场合，伪人是八面玲珑的存在，因为他们切换人格面具比切换手机输入法还快。上一秒还是推心置腹的铁哥们模式，下一秒领导来了，瞬间切换成沉稳可靠好员工模式，连脸上的光泽度和卷曲度都会发生微调。你以为你交到了一个真心懂你的朋友？醒醒。你只是幸运地遇到了一个善于伪装、高性能的仿生人罢了。夜深人静时，伪人把面具一层层摘下来，最后才发现，面具下空得很，正是这些面具构成了自己。',
  },
  OJBK: {
    code: 'OJBK',
    cn: '无所谓人',
    intro: '我说随便，是真的随便。',
    desc: '让我们直面这个词的粗犷本质：OJBK。这已经不是一种人格，而是一种统治哲学。当凡人面临"中午吃米饭还是面条"的世纪抉择时，大脑在激烈燃烧卡路里；而OJBK人格，会用一种批阅奏章般的淡然，轻飘飘地吐出两个字：都行。这不是没主见，这是在告诉你：尔等凡俗的选择，于朕而言，皆为蝼蚁。为什么不争执？因为跟草履虫辩论宇宙的未来毫无意义。为什么不较真？因为帝王不会在意脚下的尘埃是往左飘还是往右飘。',
  },
  MALO: {
    code: 'MALO',
    cn: '吗喽',
    intro: '人生是个副本，而我只是一只吗喽。',
    desc: '朋友，你不是"童心未泯"，你压根就没进化。你的灵魂还停留在那个挂在树上荡秋千、看见香蕉就两眼放光的快乐时代。当人类祖先决定从树上下来、学会直立行走、穿上西装打领带时，吗喽人格的祖先在旁边的大树上看着他们，挠了挠屁股，嘴里发出一声不屑的"吱"。他们看透了一切：所谓的"文明"，不过是一场最无聊、最不好玩的付费游戏。规则偶尔是可以打破的，天花板是用来倒挂的，会议室是用来表演后空翻的。MALO本身就是一个从巨大脑洞里掉出来、忘了关门的奇思妙想。',
  },
  'JOKE-R': {
    code: 'JOKE-R',
    cn: '小丑',
    intro: '原来我们都是小丑。',
    desc: '请注意，JOKE-R人格不是一个"人"，更像一个把笑话穿在身上的小丑。你打开一层，是个笑话；再打开一层，是个段子；你一层层打开，直到最后，你发现最里面……是空的，只剩下一点微弱的回声在说：哈，没想到吧。JOKE-R是社交场合的气氛组组长兼唯一指定火力输出。有他们在，场子就不会冷。所有人前仰后合地笑着，而笑得最开心的，往往也是他们自己——用最大的笑声，盖住心碎的声音。',
  },
  'WOC!': {
    code: 'WOC!',
    cn: '握草人',
    intro: '卧槽，我怎么是这个人格？',
    desc: '我们发现了一种神奇的生物——WOC!人。他们拥有两种完全独立的操作系统：一个叫"表面系统"，负责发出"我操""牛逼""啊？"等一系列大惊小怪的拟声词；另一个叫"后台系统"，负责冷静分析：嗯，果然不出我所料。WOC!人只会卧槽，不会多管闲事，因为他们深知，给傻逼讲道理，就像扶着烂泥上墙，不仅浪费体力，还弄自己一手屎。所以他们选择，握着一根智慧的大草，用一声饱含深情的"WOC！"来为这个疯狂的世界献上最高敬意。',
  },
  'THIN-K': {
    code: 'THIN-K',
    cn: '思考者',
    intro: '已深度思考100s。',
    desc: '经研究发现，THIN-K人格的大脑构造与常人有根本性不同。正如名称所示，您的大脑长时间处于思考状态。您十分会审判信息，注重论点、论据、逻辑推理、潜在偏见，乃至"作者本人三代以内思想背景调查报告"的全套材料。在这个信息爆炸的时代，您绝不会轻易盲从，会在关系中衡量利弊，也十分捍卫自己的自我空间。当别人看到您独处时在发呆？愚蠢，那不是发呆，那是您的大脑正在对今天接收到的所有信息进行分类、归档和销毁。',
  },
  SHIT: {
    code: 'SHIT',
    cn: '愤世者',
    intro: '这个世界，构石一坨。',
    desc: '恭喜您，SHIT人格是宇宙中已知的唯一一种稀有人格。所谓狗屎，并不是在抱怨，而是在进行一种神秘仪式。SHIT的行为模式是一场惊天动地的悖论戏剧。嘴上：这个项目简直是屎。手上：默默打开 Excel，开始建构函数模型和甘特图。嘴上：这帮同事都是 shit。手上：在同事搞砸之后，一边烦着，一边熬夜把烂摊子收拾得明明白白。嘴上：这个世界就是一坨 shit，赶紧毁灭吧。手上：第二天早上七点准时起床，挤上 shit 一样的地铁，去干那份 shit 一样的工作。别怕，那不是世界末日的警报，那是他马上要开始拯救世界的冲锋号。',
  },
  ZZZZ: {
    code: 'ZZZZ',
    cn: '装死者',
    intro: '我没死，我只是在睡觉。',
    desc: '恭喜您，您测出了全中国最稀有的装死人格。群里99+条消息您可以视而不见，但当有人发出"@全体成员 还有半小时就截止了"的最后通牒时，您也许会像刚从千年古墓里苏醒一样，缓缓地敲出一个"收到"，然后在29分钟内，交出一份虽然及格的答卷。是的，直到"死线"这个唯一的、最高权限的指令出现，您就真正爆发了，不鸣则已，一鸣惊人。您向宇宙证明了一个真理：有时什么都不做，就不会做错。',
  },
  POOR: {
    code: 'POOR',
    cn: '贫困者',
    intro: '我穷，但我很专。',
    desc: '恭喜您，您测出了【POOR - 贫困者】。这个"贫困"不是钱包余额的判决书，更像一种欲望断舍离后的资源再分配。别人把精力撒成漫天二维码，你把精力压成一束激光，照哪儿，哪儿就开始冒烟。POOR的世界很简单：不重要的东西一律降噪，重要的东西狠狠干到底。热闹、社交、虚荣、到处刷存在感？抱歉，没空。你不是资源少，你是把资源全部灌进了一个坑里，所以看起来像贫困，实际上像矿井。一旦某件事被你认定值得钻，外界再吵也只是背景杂音。',
  },
  MONK: {
    code: 'MONK',
    cn: '僧人',
    intro: '没有那种世俗的欲望。',
    desc: '当别人在KTV里参悟爱与恨的纠缠，MONK人格选择在家中参悟一份大道。MONK已然看破红尘，不希望闲人来扰其清修、破其道行。MONK的个人空间，是他们的结界，是他们的须弥山，是他们的绝对领域，神圣不可侵犯。踏入者，会感受到一种来自灵魂深处的窒息感。MONK们不黏不缠，因为在他们的世界观里，万物皆有其独立轨道。行星与行星之间保持着亿万公里的距离，才构成和谐宇宙，人与人之间为什么不行？',
  },
  IMSB: {
    code: 'IMSB',
    cn: '傻者',
    intro: '认真的么？我真的是傻逼么？',
    desc: '恭喜您！您根本不在人类范畴内！您测出了百万年一遇的【IMSB】人格。IMSB人格的大脑里住着两个不死不休的究极战士：一个叫"我他妈冲了！"，另一个叫"我是个傻逼！"。当IMSB面对一个有好感的人时，前者会说：冲啊！去要微信！去约饭！爱要大声说出来！后者接着说：人家凭什么看得上你？你去了就是自取其辱！最终结果：盯着对方背影直到消失，然后掏出手机搜索"如何克服社交恐惧症"。IMSB不是真的傻，只是您的内心戏，可能比漫威宇宙所有电影加起来都长。',
  },
  SOLO: {
    code: 'SOLO',
    cn: '孤儿',
    intro: '我哭了，我怎么会是孤儿？',
    desc: '恭喜您，您测出了全中国最稀有的【SOLO - 孤儿】人格。别急着哭，国王的加冕仪式，通常都是一个人。孤儿的自我价值感偏低，因此有时主动疏远他人，孤儿们在自己的灵魂外围建起了一座名为"莫挨老子"的万里长城。每一块砖，都是过去的一道伤口。孤儿就像一只把所有软肋都藏起来，然后用最硬的刺对着世界的刺猬。那满身的尖刺不是攻击，那是一句句说不出口的"别过来，我怕你也受伤"和"求求你，别离开"。',
  },
  FUCK: {
    code: 'FUCK',
    cn: '草者',
    intro: '操！这是什么人格？',
    desc: '恭喜您！您根本不在人类范畴内！您测出了百万年一遇的【FUCK】人格。人类文明城市里，出现了一株无法被任何除草剂杀死的、具有超级生命力的人形野草——那就是草者人格。它的学名，就叫 FUCK。在FUCK的世界观里，世俗规则简直毫无意义，并且FUCK的情绪开关是物理拨片式的：FUCK YEAH 和 FUCK OFF。FUCK追求的不只是当下快感，也在追求一种在体内横冲直撞的生命力。当所有人都被驯化成了温顺家禽，FUCK则是荒野上最后那一声狼嚎。',
  },
  DEAD: {
    code: 'DEAD',
    cn: '死者',
    intro: '我，还活着吗？',
    desc: '恭喜您，您测出了全中国最为罕见的人格，只是"死者"这个名字实在有点晦气，所以也可以叫：Don\'t Expect Any Drives。死者已经看透了那些无意义的哲学思考，因此显得对一切"失去"了兴趣。死者们看世界的眼神，就像一位顶级玩家通关了所有主线、支线、隐藏任务，删档重开了999次之后，终于发现：这游戏压根就没意思。死者是超越了欲望和目标的终极贤者。他们的存在，就是对这个喧嚣世界最沉默也最彻底的抗议。',
  },
  IMFW: {
    code: 'IMFW',
    cn: '废物',
    intro: '我真的……是废物吗？',
    desc: '恭喜您，您测出的不是一个普通人格，您是一种极其珍稀的、仅占世界人口0.0001％的——【废物】。废物们的自尊通常有些脆弱，缺乏安全感，偶尔也会缺乏主见，因此这种人格能精确地感知到周围最强的那个 WiFi 信号——也就是他们心里最可靠的人。走进【废物】人格的生活，就像走进了一个顶级兰花温室：需要精确控制温度、湿度，以及每天定时进行"我爱你"的言语光合作用。给废物一颗糖，他们会还你一个完全信任你、亮晶晶的眼神。你未必是废物，你只是太没防备，太容易认真。',
  },
  HHHH: {
    code: 'HHHH',
    cn: '傻乐者',
    intro: '哈哈哈哈哈哈。',
    desc: '恭喜您！由于您的思维回路过于清奇，标准人格库已全面崩溃。第一人格匹配率只有60％以下时，系统才会为您强制匹配这个人格——【HHHH - 傻乐者】。这个人格有什么特质？哈哈哈哈哈哈哈哈哈哈哈哈！对不起，这就是全部的特质了。您可以查看十五维度进行不专业的评估，实在是抱歉！作者设置人格时没有考虑全面，因此才会出现这样的状况。哈哈哈哈哈哈……笑着笑着，我便哭了出来。怎么会有人的脑回路这么新奇。',
  },
  DRUNK: {
    code: 'DRUNK',
    cn: '酒鬼',
    intro: '烈酒烧喉，不得不醉。',
    desc: '您为什么走路摇摇晃晃？您为什么总是情绪高涨？您为什么看东西是重影的？因为您体内流淌的不是血液，是美味的五粮液！是国窖1573！是江小白！是陕西五粮液！哦，美味的白酒，每一滴都在燃烧，都在沸腾。您是否已经习惯了将白酒灌入保温杯，当作白开水一饮而下？多么伟大的白酒！它让您在饭桌上谈笑风生，在厕所里抱着马桶忏悔人生；它让您觉得自己是夜场诗人，是宇宙中心那团不灭的火，直到第二天上午十点，您的头像裂开的核桃，嘴角挂着食物残渣，灵魂缩在角落里。您终于明白，昨晚那个高谈阔论、拍桌怒吼的人，已经成为了一个酒鬼。',
  },
};

export const TYPE_IMAGES: Record<string, string> = {
  IMSB: '/images/imsb.png',
  BOSS: '/images/boss.png',
  MUM: '/images/mum.png',
  FAKE: '/images/fake.png',
  'Dior-s': '/images/dior-s.png',
  DEAD: '/images/dead.png',
  ZZZZ: '/images/zzzz.png',
  GOGO: '/images/gogo.png',
  FUCK: '/images/fuck.png',
  CTRL: '/images/ctrl.png',
  HHHH: '/images/hhhh.png',
  SEXY: '/images/sexy.png',
  OJBK: '/images/ojbk.png',
  'JOKE-R': '/images/joke-r.png',
  POOR: '/images/poor.png',
  'OH-NO': '/images/oh-no.png',
  MONK: '/images/monk.png',
  SHIT: '/images/shit.png',
  'THAN-K': '/images/than-k.png',
  MALO: '/images/malo.png',
  'ATM-er': '/images/atm-er.png',
  'THIN-K': '/images/thin-k.png',
  SOLO: '/images/solo.png',
  'LOVE-R': '/images/love-r.png',
  'WOC!': '/images/woc.png',
  DRUNK: '/images/drunk.png',
  IMFW: '/images/imfw.png',
};

export const NORMAL_TYPES: NormalType[] = [
  { code: 'CTRL', pattern: 'HHH-HMH-MHH-HHH-MHM' },
  { code: 'ATM-er', pattern: 'HHH-HHM-HHH-HMH-MHL' },
  { code: 'Dior-s', pattern: 'MHM-MMH-MHM-HMH-LHL' },
  { code: 'BOSS', pattern: 'HHH-HMH-MMH-HHH-LHL' },
  { code: 'THAN-K', pattern: 'MHM-HMM-HHM-MMH-MHL' },
  { code: 'OH-NO', pattern: 'HHL-LMH-LHH-HHM-LHL' },
  { code: 'GOGO', pattern: 'HHM-HMH-MMH-HHH-MHM' },
  { code: 'SEXY', pattern: 'HMH-HHL-HMM-HMM-HLH' },
  { code: 'LOVE-R', pattern: 'MLH-LHL-HLH-MLM-MLH' },
  { code: 'MUM', pattern: 'MMH-MHL-HMM-LMM-HLL' },
  { code: 'FAKE', pattern: 'HLM-MML-MLM-MLM-HLH' },
  { code: 'OJBK', pattern: 'MMH-MMM-HML-LMM-MML' },
  { code: 'MALO', pattern: 'MLH-MHM-MLH-MLH-LMH' },
  { code: 'JOKE-R', pattern: 'LLH-LHL-LML-LLL-MLM' },
  { code: 'WOC!', pattern: 'HHL-HMH-MMH-HHM-LHH' },
  { code: 'THIN-K', pattern: 'HHL-HMH-MLH-MHM-LHH' },
  { code: 'SHIT', pattern: 'HHL-HLH-LMM-HHM-LHH' },
  { code: 'ZZZZ', pattern: 'MHL-MLH-LML-MML-LHM' },
  { code: 'POOR', pattern: 'HHL-MLH-LMH-HHH-LHL' },
  { code: 'MONK', pattern: 'HHL-LLH-LLM-MML-LHM' },
  { code: 'IMSB', pattern: 'LLM-LMM-LLL-LLL-MLM' },
  { code: 'SOLO', pattern: 'LML-LLH-LHL-LML-LHM' },
  { code: 'FUCK', pattern: 'MLL-LHL-LLM-MLL-HLH' },
  { code: 'DEAD', pattern: 'LLL-LLM-LML-LLL-LHM' },
  { code: 'IMFW', pattern: 'LLH-LHL-LML-LLL-MLL' },
];

export const SPECIAL_TYPE_CODES = ['HHHH', 'DRUNK'] as const;

export const ALL_TYPE_CODES = [
  ...NORMAL_TYPES.map(t => t.code),
  ...SPECIAL_TYPE_CODES,
];
